module.exports = __webpack_public_path__ + "img/INTERIOR-SWIFT-SPORT-4.07762925.jpg";